import React from 'react';
import { sectionDictionary } from './sectionDictionary';

function SectionZone({ section, side, index, children }) {
  const { _type } = section;
  let Component;

  if (sectionDictionary.hasOwnProperty(_type)) {
    Component = sectionDictionary[section._type];
  } else {
    return null;
  }

  return (
    <Component data={section} side={side || false} index={index}>
      {children}
    </Component>
  );
}

export default SectionZone;
